import { Component, Input, ViewChild, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { ObjetivoService } from '../../../services/objetivo.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ModalService } from 'src/app/services/modal.service';
import { AlertService } from './../../../../../services/alert.service';
import { IndicadoresService } from '../../../services/indicadores.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { PlanesInstitucionalesAnualesService } from 'src/app/modulos/catalogos-admin/services/planes-institucionales-anuales.service';
import { AgrupacionIndicadoresService } from '../../../services/agrupacion-indicadores.service';
import { ConfiguracionIndicadoresService } from '../../../services/configuracion-indicadores.service';
import { EspecialDosService } from 'src/app/modulos/catalogos-proces/services/especial-dos.service';

@Component({
  selector: 'app-indicadores-objetivos',
  templateUrl: './indicadores-objetivos.component.html',
  styleUrls: ['./indicadores-objetivos.component.css']
})
export class IndicadoresObjetivosComponent implements OnChanges, OnInit, OnDestroy {
  public formObjetivoIndicadores: UntypedFormGroup;
  public submitted = false;
  public dataObjetivoIndicadores: any = [];
  public dataObjetivo: any = [];
  public dataIndicadores: any[] = [];
  public dataPlanAnios: any[] = [];
  private idDeleteRegister: number = 0;
  public idSprNivel: number = 0;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public nameModal: string = 'objetivo-modalNewEdit'
  public nameApp = 'INDICADOR-OBJETIVO';
  public selectItems: any = [];
  public idSprAmbiente: number = 0;
  public nameModalConfig: string = 'modalConfig'
  public nameModalCumple: string = 'modalCumple'
  public dataResponsableProceso: any = [];
  public dataElementosParticpantes: any = [];
  public dataEquipoGerencial!: any;
  public desripcionObjetivo!: any;
  public idSprPlanAnio: number = 0;
  public idSprAnio: number = 0;
  public dataTipoParticpacion: any = [];
  public dataIndicadorSendConfig: any[0] = [0];
  public descripcionIndicador !: any;
  public descripcionConfigIndicador !: any;
  public cumpleIndicadores = [];
  public nombreObjetivos = [];
  public lengthIndicadoresAgrupados = 0;
  public nombreTipoAgrupacion!: any;
  public nombreExpresion!: any;

  idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  idSprTipoParticipanteEquipoGerencial = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_GERENCIAL;
  public idResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;

  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;

  //Array que almacena los ids de los objetivos del plan anual seleccionado
  public dataObjetivosPorAnio: any = [];

  public objetivo: any = null;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;
  public estadoActivo: number = 1;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;


  @Input() set init(objetivo: any) {
    this.objetivo = objetivo
  }

  @Input() set idsObjetivos(dataObjetivosPorAnio: any) {

    this.dataObjetivosPorAnio = dataObjetivosPorAnio;
  }

  @Input() set planAnual(planAnioSeleccionadoRedux: any) {
    this.planAnioSeleccionadoRedux = planAnioSeleccionadoRedux;
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    public modal: ModalService,
    private indicadorService: IndicadoresService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private comunService: ComunService,
    private objetivoService: ObjetivoService,
    private participanteElementoService: ParticipanteElementoService,
    private equipoGerencialService: EquipoGerencialService,
    public store: Store<AppState>,
    private planesAniosService: PlanesInstitucionalesAnualesService,
    private agrupacionIndicadoresService: AgrupacionIndicadoresService,
    private configuracionIndicadoresService: ConfiguracionIndicadoresService,
    private especialDosService: EspecialDosService,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    //this.idSprAmbiente = this.currentUser.idSprAmbiente;
  }

  initApp(data: string = '-') {
    this.getIpPublic();
    if (data == 'objetivo') {

      this.store.select('globalApp').subscribe(response => {
        this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
        this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
        this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
        this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
        this.idSprAnio = response.planAniosSeleccionado.idSprAnio;

      })

      this.getDataAll();
      this.listEquipoGerencial();
    }
  }
  ngOnChanges(): void {
    this.initApp(this.objetivo)
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  getDataAll() {
    forkJoin([
      this.planesAniosService.list('?idSprAnio=' + this.idSprAnio),
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprPlanAnio=${this.idSprPlanAnio}&estado=${this.estadoActivo}`),
      this.indicadorService.list(),

    ]).pipe(map(
      ([planesAnios, objetivos, inidicadores]) => {
        this.dataPlanAnios = planesAnios;
        this.dataObjetivo = objetivos;
        this.dataIndicadores = inidicadores;

        this.mapingDataObjetivoIndicadores();
      })).subscribe();
  }

  getDataParticipanteElementos() {
    this.participanteElementoService.list('?estado=1').subscribe(resp => {
      this.dataElementosParticpantes = resp;
      this.mapeoProcesosParticipante();
    });
  }

  mapeoProcesosParticipante() {
    let dataProcess = [];
    for (let i = 0; i < this.dataObjetivoIndicadores.length; i++) {
      for (let j = 0; j < this.dataElementosParticpantes.length; j++) {
        if (this.dataObjetivoIndicadores[i].idSprIndicador === this.dataElementosParticpantes[j].idSprIndicador) {
          for (let k = 0; k < this.dataEquipoGerencial.length; k++) {
            if (this.dataElementosParticpantes[j].idSprEquipoGerencial === this.dataEquipoGerencial[k].idSprEquipoGerencial) {
              this.dataObjetivoIndicadores[i].gradoNombres = this.dataEquipoGerencial[k].gradoNombres;
              this.dataObjetivoIndicadores[i].idSprEquipoGerencial = this.dataElementosParticpantes[j].idSprEquipoGerencial;
              this.dataObjetivoIndicadores[i].idSprParticipanteElemento = this.dataElementosParticpantes[j].idSprParticipanteElemento;
            }
          }
        }
      }
    }
  }

  listEquipoGerencial() {
    this.equipoGerencialService.list('?idSprAmbiente=' + this.idSprAmbiente).subscribe(dataEquipoGerencial => {
      this.dataEquipoGerencial = dataEquipoGerencial;
      this.getTipoParticipacion();
    })
  }

  getTipoParticipacion() {
    this.comunService.list("?spr_idSprComun=" + this.idSprTipoParticipante).subscribe(respTipoParticipa => {
      this.dataTipoParticpacion = respTipoParticipa;
      this.mapeoEquipoGerencialTipoParticipa();
    })
  }

  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if (this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun && this.dataEquipoGerencial[i].estado == 1 && this.dataEquipoGerencial[i].idSprTipoParticipante == this.idResponsable) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }

  mapingDataObjetivoIndicadores() {
    this.dataObjetivoIndicadores = []
    let indiceUno = 0; let dataProcess: any = [];

    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataIndicadores.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataIndicadores[j].idSprObjetivo) {
          dataProcess.push({
            idSprIndicador: this.dataIndicadores[j].idSprIndicador,
            nombre: this.dataIndicadores[j].nombre,
            descripcion: this.dataIndicadores[j].descripcion,
            fechaInicio: this.dataIndicadores[j].fechaInicio,
            unidadInformacion: this.dataIndicadores[j].unidadInformacion,
            estado: this.dataIndicadores[j].estado,
            idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
            idSprResponsable: this.dataIndicadores[j].idSprResponsable
          }); indiceUno++;
        }
      }
      this.dataObjetivoIndicadores.push({
        nombreObjetivo: this.dataObjetivo[i].nombre,
        idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
        indicadores: dataProcess
      }); dataProcess = [];
    }
  }

  get appForm() {
    return this.formObjetivoIndicadores.controls;
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe(response => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin
      this.getIpPublic();
      this.setFormObjetivo();
    })
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  setFormObjetivo(idSprObjetivo: string = " ") {
    this.formObjetivoIndicadores = this.fb.group({
      idSprObjetivo: [idSprObjetivo],
      idSprIndicador: [],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      descripcion: [],
      unidadInformacion: [],
      estado: ['', [Validators.required]],
    });
  }
  delete(row: any) {
    this.idDeleteRegister = row.idSprIndicador;
    this.modal.open('delete-objetivo');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.indicadorService.update({
        "idSprIndicador": this.idDeleteRegister,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.modal.close();
        this.alert.deleteOk();
        this.initApp(this.objetivo)
      }, (err) => {
        this.alert.deleteError();
        this.modal.close();
      });
    }
  }

  configuracionIndicador(obj: any) {
    let respLengthConfig = [];
    this.setFormObjetivo()
    this.descripcionIndicador = obj.nombre;
    this.dataIndicadorSendConfig = obj;
    this.configuracionIndicadoresService.list(`?idSprIndicador=${obj.idSprIndicador}`).subscribe(resp => {
      respLengthConfig = resp
      if (respLengthConfig.length != 0) {
        this.validacionConfigExpresion(obj);
        this.validacionTipoAgrupacion(obj);
        this.openModalConfigIndicador();
      } else {
        this.openModalConfigIndicador();
      }
    })
  }

  validacionConfigExpresion(obj: any) {
    let idSprIndicadorPadre: number;
    idSprIndicadorPadre = obj.idSprIndicador;
    this.agrupacionIndicadoresService.list(`?idSprIndicadorPadre=${idSprIndicadorPadre}`).subscribe(resAgrupa => {
      this.lengthIndicadoresAgrupados = resAgrupa.length;
    })
  }

  validacionTipoAgrupacion(obj: any) {
    this.configuracionIndicadoresService.list(`?idSprIndicador=${obj.idSprIndicador}`).subscribe(respDataConfig => {
      respDataConfig.forEach(resp => {
        if (resp.idSprTipoAgrupacion != null) {
          this.especialDosService.list(`${resp.idSprTipoAgrupacion}` ).subscribe(respTipoAgrupacion => {
            this.nombreTipoAgrupacion = respTipoAgrupacion.formula;
          })
        }
        this.comunService.list(`${resp.idSprExpresion}`).subscribe(respExpresion => {
          this.nombreExpresion = respExpresion.nombre
        })
      })
    })
  }


  cumpleInit(obj: any) {
    this.descripcionConfigIndicador = obj.nombre;
    this.dataIndicadorSendConfig = obj;
    this.openModalCumpleIndicador();
  }

  editConfigIndicador(obj: any, row: any) {
    this.nombreObjetivos = row.nombreObjetivo;
    this.onResetForm();
    //this.initObjetivoIndicadores();
    this.setFormObjetivo(obj.idSprObjetivo)
    this.formObjetivoIndicadores.patchValue({
      idSprIndicador: obj.idSprIndicador,
      idSprObjetivo: obj.idSprObjetivo,
      idSprEquipoGerencial: obj.idSprResponsable,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      unidadInformacion: obj.unidadInformacion,
      fechaInicio: obj.fechaInicio,
      estado: obj.estado,
    });
    this.modal.open(this.nameModal);
  }


  //Detalle Proceso

  onSubmit() {
    this.submitted = true;
    this.formObjetivoIndicadores.value.usuario = this.currentUser.idSprUsuario;
    this.formObjetivoIndicadores.value.ip = this.ipAddress;
    this.formObjetivoIndicadores.value.idSprResponsable = this.formObjetivoIndicadores.value.idSprEquipoGerencial;

    if (!this.formObjetivoIndicadores.invalid) {
      if (this.formObjetivoIndicadores.value.idSprIndicador == null) {
        this.indicadorService.create(this.formObjetivoIndicadores.value).subscribe(
          (resp) => {
            this.initApp(this.objetivo)
            this.closeModalConfiguracion();
            this.alert.createOk();
          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.indicadorService.update(this.formObjetivoIndicadores.value).subscribe(
          (resp) => {
            this.initApp(this.objetivo)
            this.closeModalConfiguracion();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
      return;
    }
  }

  ConfguracionObjetivoInit(obj: any) {
    this.desripcionObjetivo = obj.nombreObjetivo;

  }


  /*reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }*/

  onResetForm() {
    this.submitted = false;
    this.formObjetivoIndicadores.reset();
  }

  openModal(row: any) {
    this.onResetForm();
    this.setFormObjetivo(row.idSprObjetivo);
    this.nombreObjetivos = row.nombreObjetivo;
    this.modal.open(this.nameModal);
  }

  openModalConfigIndicador() {
    this.onResetForm();
    this.modal.open(this.nameModalConfig);
  }
  openModalCumpleIndicador() {
    this.onResetForm();
    this.modal.open(this.nameModalCumple);
  }

  closeModalConfiguracion() {
    this.modal.closeId('objetivo-modalNewEdit');
    //this.reDrawDataTable()
  }
}